import category from '@/api/categories'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    category.getCategorySelected(result => {
      commit('categoryInfo', result.data.data)
      resolve(result.data.data)
    }, param)
  })
}
